import Mutations from "./websocket-mutations";
import Actions from "./websocket-actions";
import { defaultWebsocketStore } from "./websocket-state";
const store = {
  namespaced: true,
  state: defaultWebsocketStore,
  mutations: Mutations,
  actions: Actions
};
export default store;